.wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  height: 100%;
  min-height: 0;
  /* Варианты растянуты во всю ширину — без отступа они упираются в край окна. */
  padding: var(--sp-5);
}

/* Заголовок карточки «Варианты» (D12) — нужен только на мобильном, где три
   зоны ленты разъехались в отдельные карточки со своими шапками. На десктопе
   секции хватает aria-label из App.tsx: печатать то же самое видимым текстом
   было бы дублированием, а не подписью — поэтому по умолчанию скрыт. */
.boardTitle {
  display: none;
}

/* Варианты — вертикальный аккордеон во всю ширину канваса, а не колонки:
   свёрнутый вариант занимает одну строку с шапкой и сводкой. */
.board {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  overflow-y: auto;
  align-content: start;
}

.emptyBoard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sp-3);
  padding: var(--sp-8);
  text-align: center;
  color: var(--text-2);
}

.emptyTitle {
  font-size: var(--fs-lg);
  font-weight: 600;
  color: var(--text);
}

.emptyHint {
  max-width: 320px;
  font-size: var(--fs-sm);
  color: var(--text-3);
}

/* Шаблоны под кнопкой «+ Вариант»: свой предел ширины, чтобы карточки не
   растягивались во весь канвас, и текст внутри — по левому краю, в отличие от
   центрированной подсказки над ними. */
.emptyTemplates {
  width: 100%;
  max-width: 720px;
  margin-top: var(--sp-5);
  text-align: left;
}

.removeZone {
  position: sticky;
  bottom: var(--sp-4);
  align-self: center;
  padding: var(--sp-3) var(--sp-6);
  background: var(--surface);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-lg);
  color: var(--text-2);
  font-size: var(--fs-sm);
  box-shadow: var(--glass-rim), var(--shadow-modal);
}

/* Раньше на узких экранах варианты уезжали в горизонтальный свайп. Теперь они
   и так друг под другом во всю ширину, отдельная мобильная раскладка не нужна. */
.board > * {
  flex: none;
}

.addRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--sp-3);
  padding-top: var(--sp-2);
}

/* Пара кнопок пустой доски: обычное «+ Вариант» и магия. */
.emptyActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--sp-3);
}

.addBtn {
  min-width: 180px;
  justify-content: center;
  border-style: dashed;
  color: var(--text-2);
}

.addBtn:hover:not(:disabled) {
  border-style: solid;
  color: var(--text);
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Канвас перестаёт быть отдельным окном прокрутки внутри экрана: варианты
   растут в высоту и едут вместе со всей лентой — библиотекой сверху и сводкой
   снизу. Два вложенных вертикальных скролла под пальцем неразличимы. */
@media (max-width: 720px) {
  .boardTitle {
    display: block;
    margin: 0;
    padding: var(--sp-4) var(--sp-4) 0;
    font-size: var(--fs-lg);
    font-weight: 600;
    color: var(--text);
  }

  .wrap {
    height: auto;
    min-height: 100%;
    padding: var(--sp-4);
  }

  .board {
    flex: 1 0 auto;
    overflow-y: visible;
  }

  .emptyBoard {
    padding: var(--sp-7) var(--sp-5);
  }

  /* D13: ряд не переносится — «+ Вариант» и «Магия» всегда в одну строку.
     Раньше обе кнопки стояли на 100% ширины друг под другом; теперь у
     «+ Варианта» ~20% (flex: 1), у «Магии» — остальные ~80% (flex: 4): по
     ней жмут чаще (она сразу собирает вариант из библиотеки), да и подписи
     там просторнее. Порядок в JSX теперь совпадает с порядком слева направо. */
  .addRow,
  .emptyActions {
    flex-wrap: nowrap;
  }

  .addRow > *:first-child,
  .emptyActions > *:first-child {
    flex: 1;
    /* Подпись сокращена до «+» (см. VariantsBoard.tsx), но тач-зона — нет:
       кнопка не должна стать уже 44px, даже если flex-basis сжал бы её сильнее. */
    min-width: 44px;
  }

  /* :not(:first-child) — чтобы правило не задваивалось с предыдущим, когда
     кнопка одна (нет рейсов в библиотеке, «Магии» вообще нет в разметке). */
  .addRow > *:last-child:not(:first-child),
  .emptyActions > *:last-child:not(:first-child) {
    flex: 4;
  }

  .addBtn {
    width: auto;
    min-width: 0;
    /* Тач-зона по вертикали: без явной высоты кнопка садится на паддинги
       .btn (~35px) — ниже принятого минимума в 44px. Ширину «+» уже держит
       min-width выше, здесь — вторая половина того же требования. */
    min-height: 44px;
  }
}
